import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import shortid from "shortid";
import BoxTile from "@components/Global/Custom/BoxTile";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const CostsTutors = () => {
	const classes = useStyles("Costs");
	const { costGuideStore: store } = useStores();
	return (
		<Box
			component="section"
			minHeight={400}
			width="100%"
			pt={16}
			pb={12}
			pr={2}
			pl={2}
		>
			<Container maxWidth="md">
				<Box mb={8}>
					<Box
						component="h2"
						fontSize={{ xs: 22, sm: 24 }}
						fontWeight={700}
						lineHeight={"30px"}
						mt={0}
						mb={4}
					>
						How much do tutors charge?
					</Box>
					<Box
						component={"p"}
						fontSize={18}
						color={"grey.700"}
						lineHeight={1.6}
					>
						Tutors charge <strong>$25 to $80 per hour</strong> when teaching
						privately and <strong>$25 to $50 per hour</strong> when tutoring
						online. Tutoring rates for SAT and test prep are{" "}
						<strong>$45 to $100 per hour</strong> on average. Tutoring centers
						charge <strong>$100 to $200 per month</strong> for weekly sessions.
					</Box>
				</Box>
				<div>
					<TableContainer component={Paper}>
						<Table aria-label="Tutoring prices">
							<caption style={{ captionSide: "top" }}>
								Average tutoring rates
							</caption>
							<TableHead>
								<TableRow>
									<TableCell>Type</TableCell>
									<TableCell align="right">Average cost</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell component="th" scope="row">
										Private tutor
									</TableCell>
									<TableCell align="right">
										<Box fontWeight={700}>$25 &ndash; $80 per hour</Box>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										Online tutoring
									</TableCell>
									<TableCell align="right">
										<Box fontWeight={700}>$25 &ndash; $50 per hour</Box>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										SAT and test prep
									</TableCell>
									<TableCell align="right">
										<Box fontWeight={700}>$45 &ndash; $100 per hour</Box>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell component="th" scope="row">
										Tutoring centers
									</TableCell>
									<TableCell align="right">
										<Box fontWeight={700}>$100 &ndash; $200 per month</Box>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</Container>
		</Box>
	);
};

CostsTutors.propTypes = {};
export default CostsTutors;
